import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import { openNotification } from "../Components/Notification/Index";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL ?? "https://api.qualifyme.ai",
  timeout: 60000 * 8, 
});

// Initialize API key from query params on module load
const initializeApiKey = () => {
  if (typeof window !== "undefined") {
    const searchParams = new URLSearchParams(window.location.search);
    const apiKey = searchParams.get("apiKey");
    if (apiKey) {
      localStorage.setItem("x-api-key", apiKey);
    }
  }
};

// Initialize API key when module loads
initializeApiKey();

// API Request Interceptor Configuration
apiClient.interceptors.request.use(
  (config: AxiosRequestConfig): any => {
    let token = localStorage.getItem("access-token"); 
    if (token) {
      config.headers = {
        ...config.headers,
        Authorization: `Bearer ${token}`,
      };
    }
    
    // Add x-api-key header if present
    const apiKey = localStorage.getItem("x-api-key");
    if (apiKey) {
      config.headers = {
        ...config.headers,
        "x-api-key": apiKey,
      };
    }
    
    return config;
  },
  (error: AxiosError): Promise<AxiosError> => {
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response: AxiosResponse): AxiosResponse => {
    return response;
  },
  (error: AxiosError): Promise<AxiosError> => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          localStorage.removeItem("access-token");
          if (window.location.pathname !== "/sign-in") {
            const currentPath = window.location.pathname;
            const searchParams = window.location.search;
            const redirectUrl = encodeURIComponent(currentPath + searchParams);
            window.location.href = `/sign-in?redirect_url=${redirectUrl}`;
          }
          break;
        case 403:
          if ((error.response.data as { message: string }).message === "Application limit reached") {
            openNotification("error", "Try after some time", "Company not accepting new applications at this time.");
            break;
          }
          if (window.location.pathname !== "/sign-in") {
            window.location.href = "/sign-in";
          }
          break;
        case 404:
          console.error("Resource not found.");
          break;
        case 500:
          console.error("Internal server error, please try again later.");
          break;
        default:
          console.error(`Unexpected error: ${error.response.status}`);
      }
    }
    return Promise.reject(error);
  }
);



export default apiClient;
